import React, { Component } from "react";
import { Fade, Slide } from "react-reveal";
import $ from 'jquery';
import axios from 'axios';
import { jsonpPost } from '../../../utils/jsonp';
import emailjs from '@emailjs/browser';
import '../../../styles/checkbox.css';

class Iscrizioni_battle extends Component {
    constructor(props) {
        super(props);
        this.state = ({
            "nome": '',
            "cognome": '',
            "aka": '',
            "dataNascita": null,
            "email": '',
            "cellulare": '',
            "categoria": '',
            "numero_componenti_crew": '',
            "stile":'',
            "fields": {},
            "errors": {}
        });
    }

    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        //Name
        if (!fields["nome"]) {
            formIsValid = false;
            errors["nome"] = "Inserire il nome";
        }
        //Cognome
        if (!fields["cognome"]) {
            formIsValid = false;
            errors["cognome"] = "Inserire il cognome";
        }
        //data di nascita
        if (!fields["dataNascita"]) {
            formIsValid = false;
            errors["dataNascita"] = "Inserire la data di nascita";
        }

        if (fields["dataNascita"] < '1900-01-01') {
            formIsValid = false;
            errors["dataNascita"] = "Data di nascita non valida";
        }

        if (fields["dataNascita"] >= '2017-01-01') {
            formIsValid = false;
            errors["dataNascita"] = "Data di nascita non valida";
        }
       
        
        //email
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!fields["email"]) {
            formIsValid = false;
            errors["email"] = "Inserire indirizzo email";
        } else if(typeof fields["email"] !== '' && !(regex.test(fields["email"]))) {
            formIsValid = false;
            errors["email"] = "Indirizzo email non valido";
            console.log('email non valida');
        } 

        //cellulare
        //var regex2 = /[\+\-\\/s0-9]*/;
        var regex2 = /^(\+|)*[0-9\s\/\-]*$/;
        if(fields["cellulare"] && (!(regex2.test(fields["cellulare"])) || (fields["cellulare"].length) < 10)) {
            formIsValid = false;
            errors["cellulare"] = "Numero di cellulare non valido";
        }

        //categoria
        if (!fields["categoria"]) {
            formIsValid = false;
            errors["categoria"] = "Selezionare una categoria";
        }

        //numero componenti categoria crew vs crew
        if (fields["categoria"] === "CrewVsCrew" && !fields["numero_componenti_crew"] ) {
            formIsValid = false;
            errors["numero_componenti_crew"] = "Inserisci numero di componenti";
        }
        //numero componenti categoria crew vs crew
        if (fields["categoria"] === "CrewVsCrew" && fields["numero_componenti_crew"] <3 ) {
            formIsValid = false;
            errors["numero_componenti_crew"] = "Minimo 3 componenti";
        }

        //numero componenti categoria crew vs crew
        if (fields["categoria"] === "CrewVsCrew" && fields["numero_componenti_crew"] > 10) {
            formIsValid = false;
            errors["numero_componenti_crew"] = "Massimo 10 componenti";
        }

        //numero componenti categoria crew vs crew
        if (fields["categoria"] === "Seri" && !fields["stile"]) {
            formIsValid = false;
            errors["stile"] = "Selezionare uno stile";
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    handleChange(field, e) {
        let fields = this.state.fields;
        fields[field] = (e.target.value).trim();
        this.setState({ fields });
        console.log('data nascita: '+ this.state.fields.dataNascita);
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        $('#submit').prop('disabled', true);;
        if (!this.handleValidation()) {
            console.log('Show Errori');
            $('#submit').prop('disabled', false);
        } else {
            e.preventDefault();
            
            $('#image-loader').fadeIn();
            var googleScriptUrl = this.props.data.dttm.google_apps_script_url + '?tabId=Battle';
            jsonpPost(googleScriptUrl, [{
                    "Nome": this.state.fields.nome,
                    "Cognome": this.state.fields.cognome,
                    "Aka": this.state.fields.aka,
                    "Data Nascita": this.state.fields.dataNascita,
                    "Email": this.state.fields.email,
                    "Cellulare": this.state.fields.cellulare,
                    "Categoria": this.state.fields.categoria,
                    "Data Iscrizione": new Date().toLocaleString()}])
            .then((response)=>{
                if (response && response.message === "Successfully Inserted"){
                    var nome = this.state.fields.aka === undefined? ('Nome: ' + this.state.fields.nome + ' ' + this.state.fields.cognome) : ('Aka: '+this.state.fields.aka);
                    var categoria = ', Categoria: '+ this.state.fields.categoria;
                    //var n_componenti = this.state.fields.categoria ==='CrewVsCrew'? (', Numero Elementi: ' + this.state.fields.numero_componenti_crew) : '';
                    //var stile = this.state.fields.categoria ==='Seri'? (', Stile: ' + this.state.fields.stile) : '';
                    var templateParams = {
                        nome: this.state.fields.nome,
                        cognome: this.state.fields.cognome,
                        aka: this.state.fields.aka,
                        datanascita: this.state.fields.dataNascita,
                        cellulare: this.state.fields.cellulare,
                        categoria: this.state.fields.categoria,
                        evento: 'battle',
                        tipo_evento : 'al battle',
                        data_evento: '05/04/2025',
                        message: (nome+categoria),
                        
                        destinatario: this.state.fields.email
                    };
                   emailjs.send('service_z5dnmwc', 'template_j0hg4qa', templateParams, 'J6IjFiyHdCTnQoV4v')
                            .then(function(response) {
                               console.log('SUCCESS!', response.status, response.text);
                            }, function(error) {
                               console.log('FAILED...', error);
                            });
                     
                    $("#image-loader").fadeOut();
                    $("#message-warning").hide();
                    $("#form_iscrizione").css("display", "none");
                    $("#message-success").fadeIn();
                    $('#form_iscrizione')[0].reset();
                } else {
                    $("#image-loader").fadeOut();
                    $("#message-warning").fadeIn();
                }
            })
            .catch((err)=>{
                console.log(err);
                $("#image-loader").fadeOut();
                $("#message-warning").fadeIn();
            });
        }
    }
    render() {
        if (!this.props.data) return null;

        const img_header = "images/dttm/header_iscrizioni_battle.png";
        const img_header_mobile = "images/dttm/" + this.props.data.battle.img_header_iscrizioni_mobile;
        const name_nome = this.props.data.battle.name_form.nome;
        const name_cognome = this.props.data.battle.name_form.cognome;
        const name_aka = this.props.data.battle.name_form.aka;
        const name_data_nascita = this.props.data.battle.name_form.dataNascita;
        const name_email = this.props.data.battle.name_form.email;
        const name_cellulare = this.props.data.battle.name_form.cellulare;
        const name_categoria = this.props.data.battle.name_form.categoria;
        const name_numero_componenti_crew = this.props.data.battle.name_form.numeroComponenti;

        return (
            <section id="contact">
                <Fade bottom duration={1000}>
                    <div className="row">
                        <img alt="header" id="img_header_lg" src={img_header} />
                        <img alt="header" id="img_header_xs" src={img_header_mobile} />
                    </div>
                </Fade>
                <div id="message-warning" className="text-center"> Attenzione! Si è verificato un errore imprevisto, riprovare!</div>
                <div id="message-success" className="text-center">
                    <i className="fa fa-check"></i>La tua iscrizione è stata inserita correttamente!
                    <br/>
                    <a style={{ paddingLeft: "00%" }} href="/dancetothemusic"><button style={{ backgroundColor: "#900411", marginTop:"50px", marginRight:"10px" }}>Home</button></a>
                    <a style={{ paddingLeft: "00%" }} href="/dancetothemusic_iscrizioni_battle"><button style={{ backgroundColor: "#410108", marginTop:"50px" }}>Nuova iscrizione battle</button></a>
                    <br />
                </div>
                <div className="row" id="div_main">
                    <Slide left duration={1000}>

                        <form id="form_iscrizione">
                            <fieldset>
                                <div >
                                    <hr style={{ border: "solid 1px #89050f" }} />
                                    <div className="six columns divColumn">
                                        <label htmlFor="nome">
                                            Nome <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            defaultValue=""
                                            size="35"
                                            id="nome"
                                            name={name_nome}
                                            required
                                            onChange={this.handleChange.bind(this, "nome")}
                                        />
                                        <span style={{ color: "red", "fontSize": "12px" }}>{this.state.errors["nome"]}</span>
                                    </div>

                                    <div className="six columns divColumn">
                                        <label htmlFor="cognome">
                                            Cognome <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            defaultValue=""
                                            size="35"
                                            id="cognome"
                                            name={name_cognome}
                                            required
                                            onChange={this.handleChange.bind(this, "cognome")}
                                        />
                                        <span style={{ color: "red", "fontSize": "12px" }}>{this.state.errors["cognome"]}</span>
                                    </div>


                                    <div className="six columns divColumn">
                                        <label htmlFor="aka">
                                            Aka
                                        </label>
                                        <input
                                            type="text"
                                            defaultValue=""
                                            size="35"
                                            id="aka"
                                            name={name_aka}
                                            onChange={this.handleChange.bind(this, "aka")}
                                        />
                                    </div>

                                    <div className="six columns divColumn">
                                        <label htmlFor="dataNascita">
                                            Data nascita <span className="required">*</span>
                                        </label>
                                        <input
                                            style={{ display: "block" }}
                                            type="date"
                                            min="1918-01-01" max="2022-01-31"
                                            id="dataNascita"
                                            name={name_data_nascita}
                                            required
                                            onChange={this.handleChange.bind(this, "dataNascita")}
                                            requiredpattern="\d{4}-\d{2}-\d{2}"
                                        />
                                        <span style={{ color: "red", "fontSize": "12px" }}>{this.state.errors["dataNascita"]}</span>
                                    </div>

                                    <div className="six columns divColumn">
                                        <label htmlFor="email">
                                            Email <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            defaultValue=""
                                            size="150"
                                            id="email"
                                            name={name_email}
                                            required
                                            onChange={this.handleChange.bind(this, "email")}
                                        />
                                        <span style={{ color: "red", "fontSize": "12px" }}>{this.state.errors["email"]}</span>
                                    </div>

                                    <div className="six columns divColumn">
                                        <label htmlFor="cellulare">
                                            Cellulare
                                        </label>
                                        <input
                                            type="tel"
                                            defaultValue=""
                                            size="35"
                                            id="cellulare"
                                            name={name_cellulare}
                                            onChange={this.handleChange.bind(this, "cellulare")}
                                        />
                                        <span style={{ color: "red", "fontSize": "12px" }}>{this.state.errors["cellulare"]}</span>
                                    </div>

                                    <div className="six columns divColumn">
                                        <label htmlFor="categoria">
                                            Categoria <span className="required">*</span>
                                        </label>
                                        <select name={name_categoria} className="styleInput" id="categoria" required onChange={this.handleChange.bind(this, "categoria")}>
                                            <option value="undefined">Seleziona categoria..</option>
                                            <option value="Hip Hop Under12" >1vs1 Hip Hop Cuccioli (Under 12)</option>
                                            <option value="Hip Hop Under16" >1vs1 Hip Hop Pischelli (Under 16)</option>
                                            <option value="Hip Hop Open" >1vs1 Hip Hop Seri (Open)</option>
                                        </select>
                                        <span style={{ color: "red", "fontSize": "12px" }}>{this.state.errors["categoria"]}</span>
                                    </div>

                                  {/*  {this.state.fields.categoria === "CrewVsCrew" ?
                                        <div className="six columns divColumn" id="div_n_elementi" >
                                            <label htmlFor="numero_componenti_crew">
                                                N° Elementi <span className="required">*</span>
                                                <span style={{ "fontSize": "13px" }}>(Min 3)</span>
                                            </label>
                                            <input
                                                type="number"
                                                id="numero_componenti_crew"
                                                name={name_numero_componenti_crew}
                                                onChange={this.handleChange.bind(this, "numero_componenti_crew")}
                                            />
                                            <span style={{ color: "red", "fontSize": "12px" }}>{this.state.errors["numero_componenti_crew"]}</span>
        </div> : ''}

                                        {this.state.fields.categoria === "Seri" ?
                                        <div className="six columns divColumn" id="div_stile" >
                                            <label htmlFor="stile">
                                                Stile <span className="required">*</span>
                                            </label>
                                            <select name="stile" className="styleInput" id="stile" required onChange={this.handleChange.bind(this, "stile")}>
                                            <option value="undefined">Seleziona categoria..</option>
                                            <option value="HipHop" >Hip Hop</option>
                                            <option value="House">House</option>
                                            <option value="Popping">Popping</option>
                                        </select>
                                            <span style={{ color: "red", "fontSize": "12px" }}>{this.state.errors["stile"]}</span>
                                        </div> : ''} */}

                                    <hr style={{ border: "solid 1px #89050f", "marginTop":"43px"}} />

                                    <div className="twelve columns">
                                        <button type="submit" className="submit" id="submit" onClick={this.handleSubmit}>Invia</button>
                                        <span id="image-loader">
                                            <img alt="" src="images/loader.gif" />
                                        </span>
                                    </div>




                                </div>


                            </fieldset>
                        </form>

                    </Slide>
                </div>

            </section>
        );
    }
}

export default Iscrizioni_battle;
